import script from "./CustomerInputSwishBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerInputSwishBlock.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerInputSwishBlock.vue?vue&type=style&index=0&id=6ae370a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae370a2"]])

export default __exports__